var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_69873",
    "data-name": "Raggruppa 69873",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.716,
    height: 22.46,
    viewBox: "0 0 11.716 22.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_148381",
    "data-name": "Rettangolo 148381",
    width: 11.716,
    height: 22.46,
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69872",
    "data-name": "Raggruppa 69872",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37397",
    "data-name": "Tracciato 37397",
    d: "M5.6,22.46a1.513,1.513,0,0,1-.866-.678,1.485,1.485,0,0,1-.157-.717q0-4.585,0-9.169c0-.334,0-.322-.317-.422A5.708,5.708,0,0,1,.171,7.144,5.573,5.573,0,0,1,1.313,2.173,5.543,5.543,0,0,1,4.915.079a5.714,5.714,0,0,1,5.4,1.968A5.456,5.456,0,0,1,11.659,5.03a5.73,5.73,0,0,1-1.507,4.8,5.546,5.546,0,0,1-2.733,1.655.3.3,0,0,0-.262.343q.01,2.138,0,4.277c0,.142.046.174.176.173.519-.005,1.038,0,1.557,0a.861.861,0,0,1,.9.829.872.872,0,0,1-.833.876c-.322.028-.389.1-.395.421,0,.066,0,.132,0,.2,0,.342.056.4.39.45a.879.879,0,0,1,.809.635.793.793,0,0,1-.276.866.83.83,0,0,1-.542.2c-.526,0-1.053.006-1.579,0-.145,0-.2.053-.2.187A1.388,1.388,0,0,1,6.13,22.46ZM5.864,9.127A3.287,3.287,0,1,0,2.576,5.87,3.282,3.282,0,0,0,5.864,9.127",
    transform: "translate(0 0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.df29a774edf247ceec55a803840495ad.svg";
export { ForwardRef as ReactComponent };